<div class="box" [ngClass]="{ disabled: isDisabled }">
  <div class="decrease" (click)="onDecrease()">
    <div class="button">
      <img [src]="images.PLUS_3" alt="decrease" />
    </div>
  </div>
  <div class="minutes">
    <div class="number">
      <input
        [value]="number"
        type="number"
        (change)="setNumber($event.target)"
      />
    </div>
    &nbsp;
    <span> {{ 'MINUTES' | fallbackTranslate }}</span>
  </div>
  <div class="increase" (click)="onIncrement()">
    <div class="button">
      <img [src]="images.PLUS_3_1" alt="increase" />
    </div>
  </div>
</div>
